import React, {
  useEffect,
  useState,
} from 'react';
import {
  Box, Paper, Tab, Tabs,
} from '@mui/material';
import PropTypes from 'prop-types';

function TabsWithPanels({
  tabItems, tabPanels, PanelAction, value, onChange,
}) {
  const [tab, setTab] = useState(value ?? 0);

  useEffect(() => {
    if (typeof value === 'number') {
      setTab(value);
    }
  }, [value]);

  const currentTab = value ?? tab;

  const handleChange = (e, nv) => {
    if (onChange) onChange(nv);
    if (value === undefined) {
      setTab(nv);
    }
  };

  return (
    <Paper sx={{
      maxHeight: '756px', marginTop: '24px', borderRadius: '8px',
    }}
    >
      <Box display="flex" sx={{ flexDirection: { sm: 'column', md: 'row' }, height: '56px' }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          value={currentTab}
          onChange={handleChange}
        >
          {
            tabItems.map((tab) => (
              <Tab
                key={tab.label}
                label={`${tab.label} (${tab.length})`}
                style={{ textTransform: 'unset', fontWeight: '600', fontSize: '16px' }}
              />
            ))
          }

        </Tabs>
        {
            PanelAction
        }
      </Box>
      {
          tabPanels.map((element, index) => (
            <div
              key={index}
              role="tabpanel"
              hidden={currentTab !== index}
            >
              {currentTab === index && (
                element
              )}
            </div>
          ))
      }
    </Paper>
  );
}

TabsWithPanels.propTypes = {
  tabItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    length: PropTypes.number.isRequired,
  })),
  tabPanels: PropTypes.arrayOf(PropTypes.element),
  PanelAction: PropTypes.element,
  value: PropTypes.number,
  onChange: PropTypes.func,
};

export default TabsWithPanels;
